module.exports = __webpack_public_path__ + "img/id-badge.c97a361b.svg";